module.exports = __webpack_public_path__ + "img/banner.6f845c71.png";